import axios from 'axios';
import { API_URL } from '../constants/api.constant';

/**
 * Get all positions
 * @param {Object} filters - Optional filters
 * @returns {Promise} - Promise resolving to positions data
 */
export const getPositions = (filters = {}) => axios.get(`${API_URL}/settings/positions`, { params: filters });

/**
 * Get position by ID
 * @param {string|number} id - Position ID
 * @returns {Promise} - Promise resolving to position data
 */
export const getPositionById = id => axios.get(`${API_URL}/settings/positions/${id}`);

/**
 * Create a new position
 * @param {Object} positionData - Position data to create
 * @returns {Promise} - Promise resolving to created position
 */
export const createPosition = positionData => axios.post(`${API_URL}/settings/positions`, positionData);

/**
 * Update an existing position
 * @param {string|number} id - Position ID
 * @param {Object} positionData - Position data to update
 * @returns {Promise} - Promise resolving to updated position
 */
export const updatePosition = (id, positionData) => axios.put(`${API_URL}/settings/positions/${id}`, positionData);

/**
 * Delete a position
 * @param {string|number} id - Position ID to delete
 * @returns {Promise} - Promise resolving to success status
 */
export const deletePosition = id => axios.delete(`${API_URL}/settings/positions/${id}`);

/**
 * Get positions options for select components
 * @param {Object} filters - Filter parameters
 * @returns {Promise} - Promise resolving to positions options
 */
export const getPositionsOptions = (filters = {}) => axios.get(`${API_URL}/settings/positions/options`, { params: filters });
